/**
 * Where "Apri email" takes the worker: the webmail of their own provider, read off the address.
 *
 * The button had an empty handler on the login and signup pages (Andrea's report of 05/10/2026,
 * item 9: tapped and nothing happens). `mailto:` would open a new message, not the inbox, so the
 * button links to the provider instead; on a phone those addresses open the provider's app when
 * it is installed. Domains of workers who signed up in the 90 days to 06/10/2026: gmail.com 81%,
 * then icloud, libero, hotmail, yahoo, outlook, live, virgilio, tiscali, alice; this list covers
 * about 98%. An address outside it (including Apple's private relay) gets no button rather than a
 * button that does nothing.
 */
const WEBMAIL_BY_DOMAIN: Record<string, string> = {
  'gmail.com': 'https://mail.google.com/mail/',
  'googlemail.com': 'https://mail.google.com/mail/',
  'icloud.com': 'https://www.icloud.com/mail',
  'me.com': 'https://www.icloud.com/mail',
  'mac.com': 'https://www.icloud.com/mail',
  'libero.it': 'https://mail.libero.it',
  'inwind.it': 'https://mail.libero.it',
  'iol.it': 'https://mail.libero.it',
  'blu.it': 'https://mail.libero.it',
  'giallo.it': 'https://mail.libero.it',
  'hotmail.it': 'https://outlook.live.com/mail/',
  'hotmail.com': 'https://outlook.live.com/mail/',
  'outlook.it': 'https://outlook.live.com/mail/',
  'outlook.com': 'https://outlook.live.com/mail/',
  'live.it': 'https://outlook.live.com/mail/',
  'live.com': 'https://outlook.live.com/mail/',
  'msn.com': 'https://outlook.live.com/mail/',
  'yahoo.it': 'https://mail.yahoo.com',
  'yahoo.com': 'https://mail.yahoo.com',
  'virgilio.it': 'https://mail.virgilio.it',
  'tiscali.it': 'https://mail.tiscali.it',
  'alice.it': 'https://mail.tim.it',
  'tim.it': 'https://mail.tim.it',
  'tin.it': 'https://mail.tim.it',
};

/** The webmail address for this email, or `undefined` when the provider is not one we know. */
export const webmailUrlFor = (email: string | undefined | null): string | undefined => {
  const domain = email?.trim().toLowerCase().split('@')[1];
  return domain ? WEBMAIL_BY_DOMAIN[domain] : undefined;
};
